<template>
  <vue-final-modal
    v-model="showModal"
    :click-to-close="false"
    classes="flex justify-center items-center"
  >
  
    <div class="w-screen h-screen flex justify-center items-center">
      <div class="w-10/12 h-5/6 mx-3 bg-white px-7 py-5 flex flex-col">
        <div class="flex text-lg mb-2">
          <span class="mr-auto">Add Component</span>
          <font-awesome-icon icon="times" class="opacity-50 cursor-pointer" @click="showModal=false" />
        </div>
        <div class="relative flex items-stretch">
          <input
            type="text" class="w-full"
            v-model="name"
            :class="{
              'border-b-2': true,
              'bg-red-50': invalid 
            }"
            placeholder="component name"
            @click="loadGlobalComponents"
            @keyup="loadGlobalComponents"
            @blur="handleBlur"
          />
          <div v-if="name && !invalid" class="bg-gray-200 ml-2 h-full">
            <div class="cursor-pointer hover:bg-white px-2 whitespace-nowrap" @click="createNew">
              Create new
            </div>
          </div>
        </div>
        <div class="flex flex-wrap overflow-auto">
          <div v-if="nodeId && localComponents.length > 0" class="flex flex-wrap pt-2 w-full">
            <label class="w-full text-xs mb-1">Local components</label>
            <div v-for="comp of localComponents" :key="comp._id" class="w-1/2 px-2">
              {{ comp.name }}
              <button class="opacity-80 ml-2" @click="addDep(comp._id)">
                Add
              </button>
            </div>
          </div>
          <label class="w-full text-xs mb-1 pt-2">Global components</label>
          <div v-for="comp of globalComponents" :key="comp._id" class="w-1/4 px-2 mb-2 border mr-2">
            <label>{{ comp.name }}</label>
            <div v-if="!cids.includes(comp._id)" class="flex text-sm action-btns opacity-80">
              <button class="mr-2" @click="createFromGlobal(comp, true)">
                Copy
              </button>
              <button @click="createFromGlobal(comp, false)">
                Direct Use
              </button>
            </div>
            <div v-else class="flex text-sm action-btns opacity-80">
              Already added
            </div>
          </div>
        </div>
        <div class="ml-auto mt-auto mr-5 flex items-center">
          <div
            v-if="globalComponentsPage - 1 > 0"
            @click="globalComponentsPage --"
            class="cursor-pointer"
          >&lt;</div>
          <div
            v-for="page of pages"
            :key="page"
            @click="globalComponentsPage = page"
            class="mx-2 cursor-pointer"
            :class="page === this.globalComponentsPage ? 'font-bold': ''"
          >
            {{ page + 1 }}
          </div>
          <div
            v-if="globalComponentsPage + 1 < Math.ceil(this.globalComponentsCount / this.globalComponentsPerPage)"
            @click="globalComponentsPage ++"
            class="cursor-pointer"
          >&gt;</div>
        </div>
      </div>
    </div>
  </vue-final-modal>
</template>
<script>
import * as compService from '../service/component'

export default {
  name: 'AddComponent',
  props: {
    components: {
      type: Array,
      default: () => ([])
    },
    nodeId: {
      type: String
    }
  },
  watch: {
    showModal () {
      this.loadGlobalComponents()
    },
    globalComponentsPage () {
      this.loadGlobalComponents()
    }
  },
  computed: {
    localComponents () {
      const node = this.components.find(c => c._id === this.nodeId)
      return this.components.filter(c => (c.name !== 'app' && c._id !== this.nodeId && !node.deps.includes(c._id)))
    },
    cids () {
      return this.components.map(c => c._id)
    },
    invalid () {
      return !!(this.components.find(c => c.name === this.name))
    },
    pages () {
      const numPages = Math.ceil(this.globalComponentsCount / this.globalComponentsPerPage)
      const pages = [-2, -1, 0, 1, 2].map(delta => this.globalComponentsPage + delta)
        .filter(page => page >=0 && page < numPages)
      return pages
    }
  },
  data () {
    return {
      name: '',
      globalComponents: [],
      showModal: false,
      globalComponentsPage: 0,
      globalComponentsPerPage: 20,
      globalComponentsCount: 0,
    }
  },
  mounted () {
    this.loadGlobalComponents()
  },
  methods: {
    handleBlur () {
      if (!this.name) {
        this.needLoad = false
      }
    },
    addDep(compId) {
      this.$emit('addDep',compId)
      this.showModal = false
    },
    createNew () {
      this.needLoad = false
      const { name } = this
      this.$emit('new', {
        template: `<div>${name} component template</div>`,
        name,
        props: [],
        data: [],
        deps: []
      })
      this.name = ''
      this.globalComponents = []
      this.showModal = false
    },
    createFromGlobal (comp, copy = false) {
      const id = copy ? null : comp._id
      this.needLoad = false
      this.$emit('new', {
        ...comp,
        is_global: !copy,
        _id: id,
        old_id: id
      })
      this.name = ''
      this.globalComponents = []
    },
    async loadGlobalComponents () {
      this.needLoad = true
      if (this.timeout) { clearTimeout(this.timeout) }
      this.timeout = setTimeout(async () => {
        const res = await compService.getGlobalComponents(this.globalComponentsPage, this.globalComponentsPerPage, this.name)
        this.globalComponentsCount = res.count
        if (this.needLoad) {
          this.globalComponents = res.components
        }
      }, 300)
    }
  }
}
</script>
